import React           from 'react';
import logo            from '../../images/logo.png';
import tf              from '../../images/tf.png';
import { makeStyles }  from '@material-ui/core/styles';

var clsx = require('classnames')

const useStyles = makeStyles(() => ({
    root: {
        height:         100,
        width:          '33.3vw',
        display:        'flex',
        justifyContent: 'flex-end',
    },
    image: {
        height:             100,
        minWidth:           60,
        marginLeft:         10,
        marginRight:        10,
        backgroundPosition: 'center',
        backgroundSize:     'contain',
        backgroundRepeat:   'no-repeat',
    },
    logo: {
        backgroundImage: `url(${ logo })`
    },
    tf: {
        backgroundImage: `url(${ tf })`
    }
}))

type LogosProps = {
    size:       number[];
    wideScreen: boolean;
}

const Logos: React.FC<LogosProps> = ({ size, wideScreen }) => {

  const classes = useStyles();


  const [rootStyle, imageStyle] = React.useMemo(() => {
      return [
          {
            width: wideScreen ? '50vw' : (size[0] - 70)
          },
          {
            width: wideScreen ? 100 : 85,
          }
      ]
  },[size, wideScreen])


  return (
    <div 
       className = { classes.root }
       style     = { rootStyle }
    >
        <div
           className = { clsx(classes.image, classes.tf) }
           style     = { imageStyle }
        />
        <div
           className = { clsx(classes.image, classes.logo) }
           style     = { imageStyle }
        />
    </div>
  );
}



export default Logos;
